export enum RoleTypeEnum {
    ROLE_UNKNOWN,
    ROLE_INFRST_MANAGER,
    ROLE_INFRST_SAFEFY,
    ROLE_INFRST_SERVICE_PROVIDER,
    ROLE_INFRST_PRIVILEGED,
    ROLE_INFRST_OBSERVER,
    ROLE_OP_MANAGER,
    ROLE_OP_PILOT
}